import { motion } from "framer-motion";
import { Mail, Phone, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { ASSETS } from "./assets";

export default function ContactScene() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden" data-testid="home-contact-section">
      <div className="max-w-[90rem] mx-auto px-6 md:px-14 grid grid-cols-1 lg:grid-cols-2 items-center gap-10">
        <Reveal>
          <div className="relative inline-block mb-8">
            <motion.img
              src={ASSETS.check} alt="MedVerify verification"
              className="h-16 w-16 scene-blend"
              initial={{ scale: 0, rotate: -30 }}
              whileInView={{ scale: 1, rotate: 0 }}
              viewport={{ once: false }}
              transition={{ type: "spring", stiffness: 160, damping: 14, delay: 0.3 }}
              data-testid="contact-check-img"
            />
            <span className="verify-pulse absolute inset-0 rounded-full" />
          </div>
          <h2 className="font-display text-[#12294d] text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]" data-testid="home-contact-title">
            Contact
          </h2>
          <a href="mailto:info@medverifys.com" data-testid="contact-cta-button" className="btn-primary rounded-full px-8 py-4 text-sm font-bold inline-flex items-center gap-2 mt-10">
            Get In Touch <ArrowRight size={16} />
          </a>
          <div className="mt-12 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8">
            <p className="text-lg text-[#12294d] font-bold whitespace-nowrap">
              Med<span className="text-[#2ab5cf]">Verify</span> Services
            </p>
            <a href="mailto:info@medverifys.com" data-testid="home-contact-email" className="inline-flex items-center gap-2.5 text-slate-600 font-medium hover:text-[#2ab5cf] transition-colors whitespace-nowrap">
              <Mail size={16} className="text-[#2ab5cf]" /> info@medverifys.com
            </a>
            <a href="tel:+919867171984" data-testid="home-contact-phone" className="inline-flex items-center gap-2.5 text-slate-600 font-medium hover:text-[#2ab5cf] transition-colors whitespace-nowrap">
              <Phone size={16} className="text-[#2ab5cf]" /> +91 98671 71984
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <img
            src={ASSETS.contactScene}
            alt="MedVerify employee and healthcare professional"
            className="w-full max-w-xl mx-auto scene-blend breathe"
            loading="lazy"
            data-testid="contact-scene-img"
          />
        </Reveal>
      </div>
    </section>
  );
}
